import { useMemo } from 'react'

import { deriveAppCapabilities } from '../utils/deriveAppCapabilities'

/**
 * React hook wrapper — memoizes `deriveAppCapabilities` over config and settings references.
 *
 * @param {object} params
 * @param {object|null} params.projectConfig - Configuration object from panel-config.json
 * @param {object|null} params.panelSettings - Configuration object from panel-settings.json
 * @returns {ReturnType<typeof deriveAppCapabilities>} Memoized app capabilities object
 */
export function useAppCapabilities({projectConfig, panelSettings}) {
  return useMemo(
    () => deriveAppCapabilities(projectConfig, panelSettings), 
    [projectConfig, panelSettings]
  )
}